import React, { useEffect, useState} from 'react';
import styles from './FinalistCarousel.module.scss';
import {finalists} from "components/homePanels/e_contest/Finalists.data";
import {buttonClick} from "utils/Helpers";
import NavToggle from "components/icons/navToggle/NavToggle";

const FinalistCarousel = ({activeFinalist,setActiveFinalist,close,winnersOnly}) => {

    const [activeImage, setActiveImage] = useState(0);

    const [carouselAssets, setCarouseAssets] = useState();


    useEffect(()=>{
        setCarouseAssets(finalists[activeFinalist].carousel);
    }, [activeFinalist])

    const videoRef = (el) => {
        if(el){
            console.log('update');
            el.load();
        }
    }

    const buttonAttributes = {
        tabIndex: 0,
        role: 'button',
        onKeyDown: (e)=>buttonClick(e)
    }

    function changeFinalist(next){
        let changeTo;
        let finalIndex = finalists.length-1;

        if(next){
            changeTo = activeFinalist === finalIndex ? 0 : activeFinalist + 1;
        } else {
            changeTo = activeFinalist === 0 ? finalIndex : activeFinalist - 1;
        }

        if(winnersOnly){
            while (!finalists[changeTo].winner){

                if(next){
                    changeTo = changeTo === finalIndex ? 0 : changeTo + 1;
                } else {
                    changeTo = changeTo === 0 ? finalIndex : changeTo - 1;
                }

            }
        }

        setActiveFinalist(changeTo)
    }

    function changeImage(next){

        let changeTo;
        let finalIndex = carouselAssets.length-1;


        if(next){
            changeTo = activeImage === finalIndex ? 0 : activeImage + 1;
        } else {
            changeTo = activeImage === 0 ? finalIndex : activeImage - 1;
        }

        setActiveImage(changeTo)
    }

    useEffect(()=>{
        setActiveImage(0)
    }, [activeFinalist,setActiveImage])

    function buildDots(){
        if(carouselAssets && carouselAssets.length > 1){

            let dots = carouselAssets.map((image, imageIndex)=>{
                return <div key={imageIndex} className={`${styles.dot} ${activeImage === imageIndex ? styles.activeDot : ''}`}/>
            })

            return (
                <>
                    <div {...buttonAttributes} className={`${styles.imageNav} ${styles.prev}`} onClick={()=>changeImage(false)}>
                        <img src={'https://msobd-storage.azureedge.net/images/gallery/carousel-arrow.png'} alt={'Previous'}/>
                    </div>
                    <div className={styles.dots}>
                        {dots}
                    </div>
                    <div {...buttonAttributes} className={`${styles.imageNav} ${styles.next}`} onClick={()=>changeImage(true)}>
                        <img src={'https://msobd-storage.azureedge.net/images/gallery/carousel-arrow.png'} alt={'Next'}/>
                    </div>
                </>
            )
        }
    }

    const showAsset = () => {

        let asset = null;
        let video = false;



        if(carouselAssets && carouselAssets[activeImage]){
            if(carouselAssets[activeImage].indexOf('.mp4') > -1){
                video = true;
                asset = (
                    <>

                        <video key={`${activeFinalist}_${activeImage}`} ref={videoRef} className={styles.video} controls playsInline
                               poster={carouselAssets[activeImage].replace('mp4','png')}>
                            <source src={carouselAssets[activeImage]} type="video/mp4"/>
                        </video>
                    </>
                )
            } else {
                let src = !carouselAssets[activeImage] ? carouselAssets[0] : carouselAssets[activeImage];
                asset = <img className={styles.image} src={src} alt={''}/>
            }
        }

        return (
            <div className={`${styles.imageBox} ${video ? styles.videoBox : ''}`}>

                {asset}
                {buildDots()}

            </div>
        )
    }

    const quote = () => {
        let activeQuote = winnersOnly ? finalists[activeFinalist].entryQuote : finalists[activeFinalist].quote;
        return <div className={styles.quote} dangerouslySetInnerHTML={{__html: `"${activeQuote}"`}}/>
    }

    return (
        <div className={styles.carouselBg}>

            <div className={styles.carousel}>
                <div {...buttonAttributes} className={`${styles.finalistNav} ${styles.prev}`} onClick={()=>changeFinalist(false)}>
                    <img src={'https://msobd-storage.azureedge.net/images/gallery/carousel-arrow.png'} alt={'Previous Creator'}/>
                </div>

                <div tabIndex={0} role={'button'} onKeyDown={buttonClick} aria-label={'Close Carousel'}  className={styles.close} onClick={close}>
                    <NavToggle menuOpen={true} closeOnly={true} color={'#fff'}/>
                </div>

                {showAsset()}

                <div className={styles.contentBox}>



                    {finalists[activeFinalist].sig && <img className={styles.sig} src={finalists[activeFinalist].sig}
                                                           alt={`${finalists[activeFinalist].name} Signature`}/>}

                    <h5 className={styles.h5}>{finalists[activeFinalist].name}<br/>

                        {finalists[activeFinalist].instagramHandle && <a className={styles.handle} href={finalists[activeFinalist].instagramLink} target={'_blank'}
                            rel={'noreferrer'}>{finalists[activeFinalist].instagramHandle}</a>}

                        {finalists[activeFinalist].tikTokHandle && <a className={styles.handle} href={finalists[activeFinalist].tikTokLink} target={'_blank'}
                            rel={'noreferrer'}>{finalists[activeFinalist].tikTokHandle}</a>}

                        {finalists[activeFinalist].location && <div className={styles.location}>{finalists[activeFinalist].location}</div>}


                    </h5>

                    {finalists[activeFinalist].bio && <div className={styles.bio} dangerouslySetInnerHTML={{__html:finalists[activeFinalist].bio}}/>}
                    {finalists[activeFinalist].quote && quote()}

                </div>

                <div {...buttonAttributes} className={`${styles.finalistNav} ${styles.next}`} onClick={()=>changeFinalist(true)}>
                    <img src={'https://msobd-storage.azureedge.net/images/gallery/carousel-arrow.png'} alt={'Next Creator'}/>
                </div>
            </div>

        </div>
    )
};

export default FinalistCarousel
